import withIcon from './NewIcon';
// @ts-ignore
import IconArrowLeftNav from './icon/nav/arrow-left.s.svg';

export default withIcon(IconArrowLeftNav);
